import { action, observable, runInAction } from 'mobx'
import { NextMiddleware, Response } from '../protocol/base-http-service'
import { RegistrationService } from '../protocol/sls-server-protocol/registration-service'
import { store } from './stores-repository'

const captchaIdKeyLower = 'x-captcha-id'
const captchaIdKeyUpper = 'X-Captcha-Id'

@store
export class SetCaptchaStore {
    static storeName: string = 'setCaptchaStore'

    /**
     * Идентификатор капчи
     */
    @observable
    captchaId: string = null

    /**
     * Картинка с символами, которые пользователь должен ввести, в формате Base64
     */
    @observable
    captchaChallenge: string = null

    /**
     * Решение пользователя
     */
    @observable
    answer: string = ''

    private registrationService: RegistrationService = null

    init = (serverUrl: string): void => {
        this.registrationService = new RegistrationService(serverUrl, {})
    }

    @action
    setAnswer = (answer: string): void => {
        this.answer = answer
    }

    @action
    getCaptchaChallenge = async (clientId: string): Promise<void> => {
        const image = await this.registrationService.getCaptchaChallenge(clientId, {
            responseMiddlewares: [(response: Response, next: NextMiddleware) => {
                /**
                 * В dev среде заголовок с ID капчи приходит в виде 'x-captcha-id'
                 * В prod среде заголовок с ID капчи приходит в виде 'X-Captcha-Id'
                 * Пробуем оба варианта
                 */
                const captchaIdHeader = response.headers?.[captchaIdKeyLower] || response.headers?.[captchaIdKeyUpper]

                if (captchaIdHeader) {
                    runInAction(() => {
                        this.captchaId = captchaIdHeader
                    })
                }
            }],
        })

        runInAction(() => {
            this.captchaChallenge = image
        })
    }
}
